import { graphql } from '@/gql';

export const SubmitSocPerformanceResultMutation = graphql(`
    mutation SubmitSocPerformanceResult($input: SubmitSocResultInput!) {
        submitSocResult(input: $input) {
            ... on SubmitSocResultSuccessfulResponse {
                result {
                    ...SocPerformanceResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);

const _SocPerformanceResult = graphql(`
    fragment SocPerformanceResult on PerformanceResult {
        id
        companyId
        company {
            id
            name
        }
        userId
        user {
            __typename
            ... on TenantUser {
                id
                name
                email
            }
            ... on SuperAdminUser {
                id
                name
                email
                isSuperAdmin
            }
        }
        isTiedToAssessmentRun
        assessmentRunId
        assessmentRun {
            name
        }
        result {
            __typename
            ... on SocResult {
                timingSec
                result
            }
        }
        createdAt
        completedAt
        updatedAt
        updatedBy
        isDeleted
    }
`);
